(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel.controller.overview
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.donut-chart.view :as donut-chart]
   [frontend.ui.component.lp-portal.bar-chart.view :as bar-chart]
   [frontend.ui.component.lp-portal.report.overview.big-figures.controller :as big-figures]
   [frontend.ui.component.chart.utils :as chart-utils]
   [frontend.ui.component.chart.water-fall :as water-fall]))

(defn- net-development
  [data]
  (let [[labels values] ((juxt :labels :net-asset-value-of-the-fund) data)]
    (bar-chart/bar-chart-config labels values :orientation :column)))

(defn- fund-nav-change-breakdown
  [{:keys [opening-nav
           net-subscriptions-by-redemptions
           income-distribution
           changes-in-fair-value-of-portfolio
           other-changes
           closing-nav]}]
  (water-fall/water-fall-config
   (->> [["Opening NAV" (first opening-nav)]
         ["Net Subscriptions / Redemptions" (first net-subscriptions-by-redemptions)]
         ["Income distribution" (first income-distribution)]
         ["Changes in fair value of portfolio" (first changes-in-fair-value-of-portfolio)]
         ["Other changes" (first other-changes)]
         ["Closing NAV" (first closing-nav)]]
        (map (fn [[k v]]
               {:name k
                :y    v})))))

(defn- portfolio-at-market-value
  [{:keys [labels portfolio-at-market-value]}]
  (map vector labels portfolio-at-market-value))

(defn- gav-breakdown
  [{:keys [labels inrev]}]
  (map vector
       labels
       (->> inrev
            (map (fn [i]
                   (/ (or i 0) 1000000))))))

(defn- market-value-by-location
  [{:keys [labels fair-market-value-by-location]}]
  (map vector labels fair-market-value-by-location))

(defn- market-value-by-currency
  [{:keys [labels market-value-by-currency-pct]}]
  (map vector labels market-value-by-currency-pct))

(defn overview
  [{:keys [dynamic-path dynamic-data report-data map-topo] :as props}]
  {:overview-figures        (report-ctl/with-footnote
                             props
                             :overview-figures-footnotes
                             (big-figures/hotel-summary-figures report-data))
   :recent-development-text (report-ctl/rich-content props :recent-development-text)
   :recent-development      (report-ctl/with-footnote props
                                                      :recent-development-footnotes
                                                      (:fund-figures report-data))
   :highlights
   (report-ctl/with-footnote
    props
    :highlight-footnotes
    (get-in report-data [:fund-figures]))
   :net-development         (report-ctl/with-footnote
                             props
                             :net-development-footnotes
                             (net-development (get-in report-data [:chart-data-nav-development])))
   :fund-nav-change-breakdown (report-ctl/with-footnote
                               props
                               :fund-nav-change-breakdown-footnotes
                               (fund-nav-change-breakdown (:chart-data-nav-development
                                                           report-data)))
   :total-return            (report-ctl/with-footnote
                             props
                             :total-return-footnotes
                             (:total-return report-data))
   :portfolio-at-market-value (report-ctl/with-footnote
                               props
                               :portfolio-at-market-value-footnotes
                               ;TODO: >> FORMAT MEUR
                               (donut-chart/donut-chart-config
                                (portfolio-at-market-value
                                 (:chart-data-market-value
                                  report-data))
                                {:data-label-formatter chart-utils/pie-float-formatter}))
   :gav-breakdown           (report-ctl/with-footnote
                             props
                             :gav-breakdown-footnotes
                             (donut-chart/donut-chart-config (gav-breakdown
                                                              (:chart-data-gav-breakdown
                                                               report-data))
                                                             {:data-label-formatter
                                                              chart-utils/pie-float-formatter}))
   :market-value-by-location (report-ctl/with-footnote
                              props
                              :market-value-by-location-footnotes
                              (donut-chart/donut-chart-config
                               (->> (market-value-by-location
                                     (:chart-data-gav-location
                                      report-data))
                                    (remove (fn [[l v]]
                                              (zero? v))))
                               {:data-label-formatter chart-utils/pie-float-formatter}))
   :market-value-by-currency (report-ctl/with-footnote
                              props
                              :market-value-by-currency-footnotes
                              ;; TODO: pass label formatter from here (%)
                              (donut-chart/donut-chart-config
                               (->> (market-value-by-currency
                                     (:chart-data-gav-currency
                                      report-data))
                                    (remove (fn [[l v]]
                                              (zero? v))))
                               {:data-label-formatter chart-utils/pie-float-formatter}))})
